import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import id from "@irati/utils/id"

import tooltipLimiter from "@irati/recognition/utils/tooltipLimiter"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"

import Tooltip, {Tip} from "../shared/Tooltip"

class TeamList extends PureComponent {
  static propTypes = {
    teams: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired,
    showMobileTooltip: PropTypes.bool
  }

  static defaultProps = {
    id: "teamList",
    showMobileTooltip: true
  }

  getText = () => {
    const {teams} = this.props
    const teamCount = teams.length

    if (teamCount > 1) {
      return `${teamCount} teams`
    } else if (teamCount === 1) {
      return get(teams, "[0].public_name")
    }

    return "Everyone"
  }

  getTooltip = () => {
    const {teams, intl} = this.props
    if (teams.length < 2) {
      return null
    }

    const arr = teams.map((team) => team.public_name)

    return (
      <Tip id={id("tooltip", this.props)}>
        {tooltipLimiter(arr, intl).map((team) =>
          <div key={team}>{team}</div>
        )}
      </Tip>
    )
  }

  render() {
    const {showMobileTooltip, teams} = this.props
    const teamCount = teams.length
    const firstTeam = get(teams, "[0].public_name")
    return (
      <Tooltip tip={this.getTooltip()} showMobile={showMobileTooltip}>
        <span><FormattedMessage id="recognition.teamList" values={{teamCount, firstTeam}} /></span>
      </Tooltip>
    )
  }
}

export default injectIntl(TeamList)
